export default {
    name: 'Màn hình tập trung',
    studentMessage: 'Bây giờ hãy tập trung vào Giáo viên',
    teacherMessage: 'Đang sử dụng màn hình tập trung.',
    close: 'Tắt',
};
